import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import React from 'react';
import { Row, Col, Radio, DatePicker, Select, Divider, Input, Button, Checkbox, Table, Space, Popover, notification } from 'antd';
// import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { isNotEmpty } from '../Service/Utils';
// import Select from 'rc-select';
import { LeftOutlined, RightOutlined, HeartOutlined, HeartTwoTone, QuestionCircleOutlined, ExportOutlined, LoadingOutlined } from '@ant-design/icons';


class ProductView extends React.Component {
    constructor() {
        super();
        this.state = {
            rangeKind: 'YESTERDAY',
            beginDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            channel: 'all',
            group: '',
            pageNo: 1,
            pageSize: 20,
            favorite: false,
            searchKey: '',
            items: [],
            paymentMeasures: ['orderUserCnt', 'orderItemBuyCnt', 'orderItemBuyRate', 'orderPayUserCnt', 'orderPayItemCnt', 'orderPayRate', 'orderPayAmount'],
            flowMeasures: ['pv', 'uv', 'addFavoriteUserCnt', 'addCartUserCnt'],
            exporting: {}
        };
    }

    render() {
        return <>
            <Row>
                <Col style={{ alignSelf: 'center' }}>
                    <span>时间：</span>
                </Col>
                <Col style={{ alignSelf: 'center' }}>
                    <Radio.Group
                        value={this.state.rangeKind}
                        onChange={({ target: { value } }) => this.refreshByDateRange(value)}
                        disabled={this.state.loading}
                    >
                        <Radio value="YESTERDAY">昨天</Radio>
                        <Radio value="AFTER_7D">7天</Radio>
                        <Radio value="AFTER_30D">30天</Radio>
                        <Radio value="DAILY">日</Radio>
                        <Radio value="WEEKLY">周</Radio>
                        <Radio value="MONTHLY">月</Radio>
                    </Radio.Group>
                </Col>
                <Col>
                    {this.state.rangeKind === 'DAILY' &&
                        <DatePicker.RangePicker
                            value={this.state.rangeDate}
                            onChange={date => {
                                if (date[0] !== undefined && date[1] !== undefined) {
                                    const duration = moment.duration(date[1].diff(date[0]));
                                    if (duration.asDays() > 90) {
                                        // TODO
                                    }
                                }
                                this.refreshItems({
                                    beginDate: date[0].format('YYYY-MM-DD'),
                                    endDate: date[1].format('YYYY-MM-DD'),
                                    rangeDate: date,
                                    pageNo: 1
                                });
                            }}
                            size="small"
                            disabled={this.state.loading}
                        />}
                    {this.state.rangeKind === 'WEEKLY' &&
                        <DatePicker.RangePicker
                            value={this.state.rangeDate}
                            onChange={date => this.refreshItems({
                                beginDate: date[0].weekday(0).format('YYYY-MM-DD'),
                                endDate: date[1].weekday(6).format('YYYY-MM-DD'),
                                rangeDate: date,
                                pageNo: 1
                            })}
                            size="small"
                            picker="week"
                        />}
                    {this.state.rangeKind === 'MONTHLY' &&
                        <DatePicker.RangePicker
                            value={this.state.rangeDate}
                            onChange={date => this.refreshItems({
                                beginDate: date[0].date(1).format('YYYY-MM-DD'),
                                endDate: date[1].date(31).format('YYYY-MM-DD'),
                                rangeDate: date,
                                pageNo: 1
                            })}
                            size="small"
                            picker="month"
                            disabled={this.state.loading}
                        />}
                </Col>
            </Row>
            <div style={{ height: 16 }}></div>
            <Row>
                <Col style={{ alignSelf: 'center' }}>
                    <span>销售渠道：</span>
                </Col>
                <Col flex="200px">
                    <Select
                        value={this.state.channel}
                        onChange={channel => this.refreshItems({ channel })}
                        style={{ width: '100%' }}
                        size="small"
                        disabled={this.state.loading}
                    >
                        <Select.Option key="0" value="all">全部</Select.Option>
                        <Select.Option key="1" value="mall">商城</Select.Option>
                        <Select.Option key="2" value="天猫">天猫</Select.Option>
                        <Select.Option key="3" value="淘宝">淘宝</Select.Option>
                        <Select.Option key="4" value="抖音">抖音</Select.Option>
                        <Select.Option key="5" value="小红书">小红书</Select.Option>
                        <Select.Option key="6" value="当当">当当</Select.Option>
                        <Select.Option key="7" value="快手">快手</Select.Option>
                        <Select.Option key="8" value="其他">其他</Select.Option>
                    </Select>
                </Col>
            </Row>
            <div style={{ height: 16 }}></div>
            <Row>
                <Col style={{ alignSelf: 'center' }}>
                    <span>所属团队：</span>
                </Col>
                <Col flex="200px">
                    <Select
                        value={this.state.group}
                        onChange={group => this.refreshItems({ group, pageNo: 1 })}
                        style={{ width: '100%' }}
                        size="small"
                        disabled={this.state.loading}
                    >
                        <Select.Option key="0" value="">全部</Select.Option>
                        <Select.Option key="1" value="百词斩">百词斩</Select.Option>
                        <Select.Option key="2" value="薄荷芝士派">薄荷芝士派</Select.Option>
                        <Select.Option key="3" value="柚子鸭">柚子鸭</Select.Option>
                        <Select.Option key="4" value="电商团队">电商团队</Select.Option>
                        <Select.Option key="5" value="探索组">探索组</Select.Option>
                        <Select.Option key="6" value="蛋糕英语">蛋糕英语</Select.Option>
                        <Select.Option key="7" value="履约">履约</Select.Option>
                        <Select.Option key="8" value="夜曲编程">夜曲编程</Select.Option>
                        <Select.Option key="9" value="其它">其它</Select.Option>
                        <Select.Option key="10" value="未知">未知</Select.Option>
                    </Select>
                </Col>
            </Row>
            <Divider></Divider>
            <Row>
                <Col flex="300px">
                    <Input.Search
                        placeholder="请输入商品ID/商品名称/存货编码"
                        allowClear
                        enterButton="搜索"
                        size="small"
                        onSearch={searchKey => this.refreshItems({ pageNo: 1, searchKey })}
                        disabled={this.state.loading}
                    />
                </Col>
                <Col flex="auto"></Col>
                <Col style={{ alignSelf: 'center' }}>
                    <Checkbox
                        checked={this.state.favorite}
                        onChange={({ target: { checked } }) => this.refreshItems({ favorite: checked })}
                        disabled={this.state.loading}
                    >我的关注</Checkbox>
                </Col>
            </Row>
            <Divider></Divider>
            {this.state.channel === 'mall' && <>
                <Row>
                    <Col>
                        <Popover content={<>
                            <p>PV：商品详情页访问次数。商品的PV=子商品的PV</p>
                            <p>UV：商品详情页访客数，周期内去重统计。商品的UV=子商品的UV</p>
                            <p>收藏人数：点击收藏的人数</p>
                            <p>加购人数：点击加入购物车的人数</p>
                        </>} title="流量指标（仅商城有，第三方渠道无法统计流量数据）">
                            <span><QuestionCircleOutlined /> 流量指标：</span>
                        </Popover>
                    </Col>
                    <Col flex="auto">
                        <Checkbox.Group
                            value={this.state.flowMeasures}
                            onChange={flowMeasures => this.setState({ flowMeasures })}
                            style={{ width: '100%' }}
                        >
                            <Row>
                                <Col flex="110px" style={{ textAlign: 'start' }}>
                                    <Checkbox value="pv">PV</Checkbox>
                                </Col>
                                <Col flex="110px" style={{ textAlign: 'start' }}>
                                    <Checkbox value="uv">UV</Checkbox>
                                </Col>
                                <Col flex="110px" style={{ textAlign: 'start' }}>
                                    <Checkbox value="addFavoriteUserCnt">收藏人数</Checkbox>
                                </Col>
                                <Col flex="110px" style={{ textAlign: 'start' }}>
                                    <Checkbox value="addCartUserCnt">加购人数</Checkbox>
                                </Col>
                            </Row>
                        </Checkbox.Group>
                    </Col>
                </Row>
                <div style={{ height: 16 }}></div>
            </>}
            <Row>
                <Col>
                    <Popover content={<>
                        <p>{'下单人数：下单的人数（不一定付款，对应订单状态status>=90）'}</p>
                        <p>{'下单件数：下单的商品数量（不一定付款，对应订单状态status>=90）'}</p>
                        <p>下单转化率：下单人数/UV</p>
                        <p>支付人数：付款的人数</p>
                        <p>支付件数：付款的商品数量</p>
                        <p>支付转化率：支付人数/UV</p>
                        <p>支付金额：用户实际付款金额（未剔除后续退款）</p>
                    </>} title="销售指标">
                        <span><QuestionCircleOutlined /> 销售指标：</span>
                    </Popover>
                </Col>
                <Col flex="auto">
                    <Checkbox.Group
                        value={this.state.paymentMeasures}
                        onChange={paymentMeasures => this.setState({ paymentMeasures })}
                        style={{ width: '100%' }}
                    >
                        <Row>
                            <Col flex="110px" style={{ textAlign: 'start' }}>
                                <Checkbox value="orderUserCnt">下单人数</Checkbox>
                            </Col>
                            <Col flex="110px" style={{ textAlign: 'start' }}>
                                <Checkbox value="orderItemBuyCnt">下单件数</Checkbox>
                            </Col>
                            {this.state.channel === 'mall' && <Col flex="110px" style={{ textAlign: 'start' }}>
                                <Checkbox value="orderItemBuyRate">下单转化率</Checkbox>
                            </Col>}
                            <Col flex="110px" style={{ textAlign: 'start' }}>
                                <Checkbox value="orderPayUserCnt">支付人数</Checkbox>
                            </Col>
                            <Col flex="110px" style={{ textAlign: 'start' }}>
                                <Checkbox value="orderPayItemCnt">支付件数</Checkbox>
                            </Col>
                            {this.state.channel === 'mall' && <Col flex="110px" style={{ textAlign: 'start' }}>
                                <Checkbox value="orderPayRate">支付转化率</Checkbox>
                            </Col>}
                            <Col flex="110px" style={{ textAlign: 'start' }}>
                                <Checkbox value="orderPayAmount">支付金额</Checkbox>
                            </Col>
                        </Row>
                    </Checkbox.Group>
                </Col>
                <Col>
                    <Button
                        icon={this.state.exporting.state === 'PENDING' ? <LoadingOutlined /> : <ExportOutlined />}
                        disabled={this.state.exporting.state === 'PENDING' || this.state.loading}
                        onClick={this.beginExporting.bind(this)}

                    >导出EXCEL</Button>
                </Col>
                {/* {isNotEmpty(this.state.exporting.downloadingUrl) && <Col style={{alignSelf: 'center'}}>
                    <a href={this.state.exporting.downloadingUrl}>点击下载</a>
                </Col>} */}
            </Row>
            <div style={{ height: 16 }}></div>
            <Row>
                <Col flex="100%">
                    <Table
                        size="small"
                        style={{
                            width: '100%',
                        }}
                        dataSource={this.state.items}
                        pagination={false}
                        bordered
                        loading={this.state.loading}
                        scroll={{ x: 1300 }}
                        rowClassName={rd=>{
                            //console.log(rd.key, rd);
                            return rd.isParent ? 'site-item-grid' : 'site-sub-item-grid';
                        }}
                    >
                        <Table.Column
                            dataIndex="id"
                            key="itemId"
                            ellipsis
                            width={170}
                            title="商品ID"
                        />
                        <Table.Column
                            dataIndex="itemTitle"
                            key="itemTitle"
                            ellipsis
                            width={320}
                            title="商品名称"
                        />
                        <Table.Column
                            dataIndex="stockId"
                            key="stockId"
                            ellipsis
                            width={100}
                            title="存货编码"
                        />
                        {this.state.channel === 'all' && <Table.Column
                            dataIndex="channel"
                            key="channel"
                            ellipsis
                            width={100}
                            title="销售渠道"
                        />}
                        {this.measureContains('pv') && <Table.Column
                            dataIndex="pv"
                            key="pv"
                            ellipsis
                            width={100}
                            title="PV"
                        />}
                        {this.measureContains('uv') && <Table.Column
                            dataIndex="uv"
                            key="uv"
                            ellipsis
                            width={100}
                            title="UV"
                        />}
                        {this.measureContains('addFavoriteUserCnt') && <Table.Column
                            dataIndex="addFavoriteUserCnt"
                            key="addFavoriteUserCnt"
                            ellipsis
                            width={100}
                            title="收藏人数"
                        />}
                        {this.measureContains('addCartUserCnt') && <Table.Column
                            dataIndex="addCartUserCnt"
                            key="addCartUserCnt"
                            ellipsis
                            width={100}
                            title="加购人数"
                        />}
                        {this.measureContains('orderUserCnt') && <Table.Column
                            dataIndex="orderUserCnt"
                            key="orderUserCnt"
                            ellipsis
                            width={100}
                            title="下单人数"
                        />}
                        {this.measureContains('orderItemBuyCnt') && <Table.Column
                            dataIndex="orderItemBuyCnt"
                            key="orderItemBuyCnt"
                            ellipsis
                            width={100}
                            title="下单件数"
                        />}
                        {this.measureContains('orderItemBuyRate') && <Table.Column
                            dataIndex="uv"
                            key="orderItemBuyRate"
                            ellipsis
                            width={100}
                            title="下单转化率"
                            render={(uv, rd) => <span>{uv === 0 ? 0 : (rd.orderUserCnt * 100 / uv).toFixed(2)}%</span>}
                        />}
                        {this.measureContains('orderPayUserCnt') && <Table.Column
                            dataIndex="orderPayUserCnt"
                            key="orderPayUserCnt"
                            ellipsis
                            width={100}
                            title="支付人数"
                        />}
                        {this.measureContains('orderPayItemCnt') && <Table.Column
                            dataIndex="orderPayItemCnt"
                            key="orderPayItemCnt"
                            ellipsis
                            width={100}
                            title="支付件数"
                        />}
                        {this.measureContains('orderPayRate') && <Table.Column
                            dataIndex="uv"
                            key="orderPayRate"
                            ellipsis
                            width={100}
                            title="支付转化率"
                            render={(uv, rd) => <span>{uv === 0 ? 0.0 : (rd.orderPayUserCnt * 100 / uv).toFixed(2)}%</span>}
                        />}
                        {this.measureContains('orderPayAmount') && <Table.Column
                            dataIndex="orderPayAmount"
                            key="orderPayAmount"
                            ellipsis
                            width={100}
                            title="支付金额"
                            render={amount => Number.parseFloat(amount).toFixed(0)}
                        />}
                        <Table.Column
                            dataIndex="favorite"
                            key="operator"
                            title="操作"
                            width={60}
                            fixed="right"
                            render={(favorite, rd) => <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => this.touchFavorite(favorite, rd)}
                            >
                                {(rd.children !== null && rd.children !== undefined && rd.children.length > 0)
                                    ? <>
                                        {favorite
                                            ? <HeartTwoTone twoToneColor="#eb2f96" />
                                            : <HeartOutlined style={{ color: 'gray' }} />}
                                    </>
                                    : <></>}
                            </div>}
                        />
                    </Table>
                </Col>
            </Row>
            <div style={{ height: 16 }}></div>
            <Row justify='center'>
                <Col>
                    <Space>
                        <Button
                            onClick={() => this.refreshItems({ pageNo: this.state.pageNo - 1 })}
                            icon={<LeftOutlined />}
                            disabled={this.state.pageNo === 1 || this.state.loading}
                        ></Button>
                        <span>第{this.state.pageNo}页</span>
                        <Button
                            onClick={() => this.refreshItems({ pageNo: this.state.pageNo + 1 })}
                            icon={<RightOutlined />}
                            disabled={this.state.items.length < this.state.pageSize || this.state.loading}
                        ></Button>
                    </Space>
                </Col>
            </Row>
        </>
    }

    async componentDidMount() {
        const exporting = await UIFetchService.get('/api/v1/real_product/items_and_sub_items/exporting/latest');
        this.setState({ exporting });
        this.refreshItems({});
        auth.appendLog('实体商品-商品综合');

        if (exporting.state === 'PENDING') {
            this.pollExportTask(exporting.taskId);
        }
    }

    async refreshByDateRange(kind) {
        let date = [undefined, undefined];
        switch (kind) {
            case 'YESTERDAY':
                date[0] = moment().subtract(1, 'days');
                date[1] = date[0];
                break;
            case 'AFTER_7D':
                date[1] = moment().subtract(1, 'days');
                date[0] = moment().subtract(8, 'days');
                break;
            case 'AFTER_30D':
                date[1] = moment().subtract(1, 'days');
                date[0] = moment().subtract(31, 'days');
                break;
            case 'DAILY':
                this.setState({
                    rangeDate: [undefined, undefined],
                    rangeKind: kind,
                });
                return;
            case 'WEEKLY':
                this.setState({
                    rangeDate: [undefined, undefined],
                    rangeKind: kind,
                });
                return;
            case 'MONTHLY':
                this.setState({
                    rangeDate: [undefined, undefined],
                    rangeKind: kind,
                });
                return;
            default:
                return;
        }


        this.refreshItems({
            beginDate: date[0].format('YYYY-MM-DD'),
            endDate: date[1].format('YYYY-MM-DD'),
            rangeKind: kind,
            pageNo: 1
        });
    }

    async refreshItems(params) {
        const requestParams = [];
        const keys = [
            'group',
            'channel',
            'beginDate',
            'endDate',
            'pageNo',
            'pageSize',
            'searchKey',
            'favorite',
            'rangeKind'
        ]
        //console.log(params);
        for (let key of keys) {
            if (params[key] === undefined) {
                params[key] = this.state[key];
            }
        }
        for (let key of keys) {
            if (isNotEmpty(params[key])) {
                requestParams.push(`${key}=${encodeURI(params[key])}`);
            }
        }
        //console.log(requestParams.join("&"));
        this.setState({ loading: true });
        const items = await UIFetchService.get(`/api/v1/real_product/items_and_sub_items?${requestParams.join("&")}`);
        for (let item of items) {
            item.isParent = true;
        }
        this.setState({ ...params, items, loading: false });
    }

    measureContains(item) {
        // orderItemBuyRate
        // orderPayRate
        if (this.state.channel !== 'mall') {
            if (item === 'orderItemBuyRate' || item === 'orderPayRate') {
                return false;
            }
            return this.state.paymentMeasures.find(it => it === item) !== undefined &&
                this.state.flowMeasures.find(it => it === item) === undefined
        }
        return this.state.paymentMeasures.find(it => it === item) !== undefined ||
            this.state.flowMeasures.find(it => it === item) !== undefined;
    }

    async touchFavorite(favorite, rd) {
        if (favorite) {
            await UIFetchService.method('DELETE', '/api/v1/real_product/favorite', [rd.subItemId > 0 ? rd.subItemId : rd.itemId]);
        } else {
            await UIFetchService.post('/api/v1/real_product/favorite', [rd.subItemId > 0 ? rd.subItemId : rd.itemId]);
        }
        this.setState(({ items }) => {
            rd.favorite = !favorite;
            return { items };
        });
    }

    async beginExporting() {
        const requestParams = [];
        const keys = [
            'group',
            'channel',
            'beginDate',
            'endDate',
            'pageNo',
            'pageSize',
            'searchKey',
            'favorite'
        ]
        for (let key of keys) {
            if (isNotEmpty(this.state[key])) {
                requestParams.push(`${key}=${encodeURI(this.state[key])}`);
            }
        }
        const taskId = await UIFetchService.post(`/api/v1/real_product/items_and_sub_items/export?${requestParams.join("&")}`, {});
        if (typeof taskId === 'number') {
            this.setState({ exporting: { state: 'PENDING', taskId } });
            this.pollExportTask(taskId);
        }

    }

    pollExportTask(taskId) {
        this.timer = setInterval(async () => {
            const exporting = await UIFetchService.get(`/api/v1/real_product/items_and_sub_items/exporting/${taskId}`);
            if (exporting.state === 'OK' || exporting.state === 'FAIL') {
                clearInterval(this.timer);
            }
            if (exporting.state === 'FAIL') {
                notification.error({
                    message: '导出EXCEL文件失败！',
                    description: exporting.logs
                });
            } else if (exporting.state === 'OK') {
                // Create blob link to download
                const link = document.createElement('a');
                link.href = exporting.downloadingUrl;
                // link.setAttribute(
                //     'download',
                //     `FileName.pdf`,
                // );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);
            }
            this.setState({ exporting });
        }, 3000);
    }
}

export default ProductView;